import { Dialog, DialogContent, DialogTitle, IconButton, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import React, { Component } from "react";
import { connect } from "react-redux";
import { injectStripe } from "react-stripe-elements";
import { bindActionCreators } from "redux";
import { getProductList, placeOrderAction } from "../../../modules/products/action";
import { formatDate } from "../../../utils/DateFormatter";
import Loader from "../../Loader";
import FarmUtilities from "../../private/FarmUtilities/FarmUtilities";
import AddressForm from "./AddressForm";
import PaymentForm from "./PaymentForm";
import Review from "./Review";
import '../../../style/main.css';

const closeButtonStyle = {
  position: "absolute",
  right: 2,
  top: 2
};

const useStyles = theme => ({
  appBar: {
    position: "relative"
  },
  layout: {
    width: "auto",
  },
  paper: {
    marginTop: 4,
    marginBottom: 4,
    padding: 16
  },
  stepper: {
    padding: "24px 0px 40px"
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end"
  },
  button: {
    marginTop: 24,
    marginLeft: 8
  }
});

const requiredFields = [
  "firstName",
  "lastName",
  "town",
  "state",
  "country",
  "zipCode",
  "streetAddress",
  "contactNo"
];

const steps = [
  "Recommended Products",
  "Shipping address",
  "Review your order",
  "Subscribe"
];

const errorHeader =
  "We regret to inform you that subscription could not be completed";

class Checkout extends Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    const { userDetails } = props;
    this.classes = useStyles();
    this.state = {
      planId: 1,
      planDetails: {},
      activeStep: 0,
      skippedStep: new Set([]),
      cartList: [],
      isDisabled: false,
      username: userDetails ? userDetails.username : "",
      firstName: userDetails ? userDetails.firstName : "",
      lastName: userDetails ? userDetails.lastName : "",
      town: userDetails ? userDetails.farmResponseDTO.address.town : "",
      state: userDetails ? userDetails.farmResponseDTO.address.state : "",
      country: userDetails
        ? userDetails.farmResponseDTO.address.country || "United States"
        : "United States",
      zipCode: userDetails ? userDetails.farmResponseDTO.address.zipCode : "",
      streetAddress: userDetails
        ? userDetails.farmResponseDTO.address.streetAddress
        : "",
      contactNo: userDetails ? userDetails.contactNo : ""
    };
  }

  componentDidMount = () => {
    this.props.getProductList();
  };

  handleChange = input => e => {
    const value = e.target.value;
    if (input === "contactNo") {
      if (value.match(/^\d{0,15}?$/)) {
        this.setState({ [input]: value });
      }
    } else this.setState({ [input]: value });
  };

  getStepContent = step => {
    const {
      firstName,
      lastName,
      town,
      state,
      country,
      zipCode,
      streetAddress,
      cartList,
      cardHolderName,
      contactNo
    } = this.state;
    const values = {
      firstName,
      lastName,
      town,
      state,
      country,
      zipCode,
      streetAddress,
      cartList,
      cardHolderName,
      contactNo
    };
    switch (step) {
      case 0:
        return (
          <FarmUtilities
            handleRemoveItem={this.handleRemoveItem}
            handlePurchase={this.handlePurchase}
            cartList={values.cartList}
          />
        );
      case 1:
        const { userDetails } = this.props;
        return (
          <AddressForm
            values={values}
            handleChange={this.handleChange}
            userDetails={userDetails}
          />
        );
      case 2:
        const { planId, subscriptionList } = this.props;
        console.log(planId);
        const planDetails =
          subscriptionList.length !== 0 &&
          subscriptionList.filter(item => {
            item.quantity = 1;
            return item.id === planId;
          });
        const currentPlan = subscriptionList[planId - 1];
        const noOfContracts =
          currentPlan && currentPlan.noOfContracts > 0
            ? currentPlan.noOfContracts
            : "Unlimited";
        const noOfTickets =
          currentPlan && currentPlan.noOfTickets > 0
            ? currentPlan.noOfTickets
            : "Unlimited";
        const noOfLogins =
          currentPlan && currentPlan.noOfLogins > 0
            ? currentPlan.noOfLogins
            : "Unlimited";
        planDetails.map(
          item =>
            (item.desc = `This plan allows you to have ${noOfContracts} contracts, ${noOfTickets} tickets and ${noOfLogins} logins`)
        );
        return (
          <Review
            planDetails={planDetails}
            products={this.props.productList.filter(item => {
              item.quantity = values.cartList.filter(
                item1 => item1 === item.productCode
              ).length;
              item.desc = item.description;
              return values.cartList.includes(item.productCode);
            })}
            values={values}
          />
        );

      case 3:
        return (
          <PaymentForm
            values={values}
            handleChange={this.handleChange}
            handleSubmit={this.submit}
            btnLabel={"Proceed to checkout"}
            isDisabled={this.state.isDisabled}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  };

  async submit(ev) {
    this.setState({
      isDisabled: true
    });
    const { cartList, username, lastName, firstName, contactNo } = this.state;
    const { planId } = this.props;
    const { state, streetAddress, town, zipCode } = this.state;
    const address = { state, streetAddress, town, zipCode };
    const arrSet = new Set(cartList);
    var productList = [];
    arrSet.forEach(item => {
      var quantity = cartList.filter(item1 => item1 === item).length;
      productList.push({ productCode: item, quantity });
    });

    console.log(productList);

    let { token } = await this.props.stripe.createToken({ name: "Name" });

    if (token) {
      this.handleNext();
      const requestData = {
        address,
        firstName,
        lastName,
        planId,
        sourceToken: token.id,
        productList,
        username,
        contactNo
      };
      this.props.placeOrderAction(requestData);
      console.log(this.props.isError, this.props.error);
      console.log(requestData);
    } else {
      this.setState({
        isDisabled: false
      });
      alert("Please enter valid card information");
    }
  }

  handlePurchase = productId => {
    this.setState(
      state => {
        const cartList = [...state.cartList, productId];
        return {
          ...state,
          cartList
        };
      },
      () => {
        console.log(productId, this.state.cartList);
      }
    );
  };

  handleRemoveItem = productId => {
    this.setState(
      state => {
        const currentCart = [...state.cartList];
        const index = currentCart.indexOf(productId);
        if (index >= 0) currentCart.splice(index, 1);
        return {
          ...state,
          cartList: currentCart
        };
      },
      () => {
        console.log(productId, this.state.cartList);
      }
    );
  };

  enableNext = () => {
    let enable = true;
    if (this.state.activeStep === 1) {
      requiredFields.every(element => {
        if (!this.state[element]) {
          enable = false;
          return false;
        } else {
          if (
            (element == "firstName" || element == "lastName") &&
            this.state[element].length < 3
          ) {
            enable = false;
            return false;
          } else {
            return true;
          }
        }
      });
      return enable;
    } else {
      return enable;
    }
  };

  handleNext = () => {
    if (this.enableNext()) {
      const { activeStep, skippedStep } = this.state;
      skippedStep.delete(activeStep);
      this.setState({ activeStep: activeStep + 1, skippedStep });
    }
    document.querySelector('#heading').scrollIntoView();
  };

  handleBack = () => {
    const { activeStep, cartList, planId } = this.state;
    if (activeStep === steps.length) this.setState({ isDisabled: false });
    if (cartList.length === 0 && planId === 1) {
      this.setState({ activeStep: 0 });
    } else this.setState({ activeStep: activeStep - 1 });
    document.querySelector('#heading').scrollIntoView();

  };

  handleGoToHomepage = () => {
    this.props.history.push("/login");
  };

  handleSkipAndSubmit = () => {
    const { planId, username, activeStep } = this.state;
    const requestData = { planId, username };
    this.setState({
      activeStep: steps.length,
      skippedStep: new Set([activeStep + 1, activeStep + 2, activeStep])
    });
    this.props.placeOrderAction(requestData);
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 2,
      skippedStep: new Set([activeStep + 1, activeStep])
    });
  };

  isStepFailed = step => {
    return step === steps.length - 1;
  };

  isStepSkipped = step => {
    const { skippedStep } = this.state;
    return skippedStep.has(step);
  };

  render() {
    const {
      classes,
      isFetchingComplete,
      isError,
      planId,
      error,
      subscriptionData
    } = this.props;
    const { activeStep, cartList } = this.state;
    const startDate = subscriptionData.subscriptionStart * 1000;
    const endDate = subscriptionData.subscriptionEnd * 1000;

    return (
      <React.Fragment>
        <Dialog
          open={this.props.open}
          fullWidth={true}
          id="test"
          //scroll={"body"}
        >
          <DialogTitle>
            <IconButton
              aria-label="Close"
              style={closeButtonStyle}
              onClick={this.props.handleClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <main className={classes.layout}>
              <Paper className={classes.paper} style={{padding : '6px'}}>
                <Typography component="h1" variant="h4" align="center" id="heading">
                  Checkout
                </Typography>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                  {steps.map((label, index) => {
                    const labelProps = {};
                    const stepProps = {};
                    if (isError && this.isStepFailed(index)) {
                      labelProps.error = true;
                    }
                    if (this.isStepSkipped(index)) {
                      stepProps.completed = false;
                    }
                    return (
                      <Step key={label} {...stepProps}>
                        <StepLabel {...labelProps}>{label}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
                <React.Fragment>
                  {activeStep === steps.length ? (
                    isFetchingComplete ? (
                      !isError ? (
                        <React.Fragment>
                          {subscriptionData &&
                          subscriptionData.subscriptionId ? (
                            <React.Fragment>
                              <Typography variant="h5" gutterBottom>
                                Thank you for choosing NTRAC.
                              </Typography>
                              <Typography variant="subtitle1">
                                You have been successfully subscribed. Your
                                subscription id is{" "}
                                {subscriptionData.subscriptionId}. Your
                                subscription is valid from{" "}
                                {formatDate(startDate)} to {formatDate(endDate)}
                              </Typography>
                              {subscriptionData.orderId && (
                                <Typography variant="subtitle1">
                                  Your order has been placed, with id{" "}
                                  {subscriptionData.orderId}. We have emailed
                                  your order confirmation and will send you an
                                  update when your order has shipped.
                                </Typography>
                              )}
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <Typography variant="h5" gutterBottom>
                                Thank you for choosing NTRAC.
                              </Typography>
                              <Typography variant="subtitle1">
                                You have been successfully subscribed to Basic
                                Plan.
                              </Typography>
                              {subscriptionData.orderId && (
                                <Typography variant="subtitle1">
                                  Your order has been placed, with id{" "}
                                  {subscriptionData.orderId}. We have emailed
                                  your order confirmation and will send you an
                                  update when your order has shipped.
                                </Typography>
                              )}
                            </React.Fragment>
                          )}
                          <div className={classes.buttons}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={this.handleGoToHomepage}
                              className={classes.button}
                            >
                              Login
                            </Button>
                          </div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Typography variant="h5" gutterBottom>
                            {errorHeader}
                          </Typography>
                          <Typography variant="subtitle1">
                            {error.split(";")[0]}
                          </Typography>
                          <div className={classes.buttons}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={this.handleBack}
                              className={classes.button}
                            >
                              Back
                            </Button>
                          </div>
                        </React.Fragment>
                      )
                    ) : (
                      <Loader />
                    )
                  ) : (
                    <React.Fragment>
                      {this.getStepContent(activeStep)}

                      <div className={classes.buttons}>
                        {activeStep !== 0 ? (
                          <Button
                            onClick={this.handleBack}
                            className={classes.button}
                          >
                            Back
                          </Button>
                        ) : (
                          planId !== 1 &&
                          cartList.length === 0 && (
                            <Button
                              onClick={this.handleSkip}
                              className={classes.button}
                            >
                              Skip
                            </Button>
                          )
                        )}
                        {activeStep !== steps.length - 1 &&
                          (planId === 1 && cartList.length === 0 ? (
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={this.handleSkipAndSubmit}
                              className={classes.button}
                            >
                              Skip and Submit
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="primary"
                              disabled={
                                (activeStep === 0 && cartList.length === 0) ||
                                !this.enableNext()
                              }
                              onClick={this.handleNext}
                              className={classes.button}
                            >
                              Next
                            </Button>
                          ))}
                      </div>
                    </React.Fragment>
                  )}
                </React.Fragment>
              </Paper>
            </main>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    productList: state.productsReducer.productList,
    isError: state.productsReducer.isError,
    error: state.productsReducer.error,
    isFetchingComplete: state.productsReducer.isFetchingComplete,
    subscriptionList: state.subscriptionList.subscriptionListDetails,
    userDetails: state.subscriptionList.tokenDetails,
    subscriptionData: state.productsReducer.subscriptionData
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getProductList, placeOrderAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(injectStripe(Checkout)));



// WEBPACK FOOTER //
// ./src/components/public/Checkout/Checkout.js